module.exports = __webpack_public_path__ + "static/media/bg_worth.810223ea.png";